// extracted by mini-css-extract-plugin
export var button = "_8-1";
export var featuredLink = "_8-4";
export var spinner = "_8-2";
export var spinnerContainer = "_8-3";
export var text = "_8-0";